import type { ChurchConfiguration } from "@lbcrm-api/church/church.responses";
import { createContext } from "react";

export const ChurchConfigurationContext = createContext<ChurchConfiguration | null>(null);
